import { useCallback, useState } from 'react';

type Config = {
  isDisabled?: boolean;
};

export default function useOverflowObserver(config: Config = {}) {
  const [isOverflowing, setIsOverflowing] = useState(false);

  const { isDisabled = false } = config;

  const ref = useCallback((node: Element) => {
    if (isDisabled) {
      return;
    }

    if (!node) {
      return;
    }

    const resizeObserver = new ResizeObserver(() => {
      const hasOverflow = node.scrollWidth > node.clientWidth;
      setIsOverflowing(hasOverflow);
    });

    resizeObserver.observe(node);
  }, []);

  return { ref, isOverflowing };
}
